import { useField } from 'formik';
export function useFieldErrors(name) {
    const field = useField(name);
    const meta = field[1];
    const hasError = Boolean(!!meta.touched && meta.error);
    const errors = (typeof meta.error === 'object' ? Object.values(meta.error) : [meta.error]);
    return hasError ? errors : [];
}
